<template>
    <div class="icon-distribution">
        <div class="title-box clearfix">
            <span class="fl">
                剩余 <span class="fl-col">{{ totalCoin }}</span> {{ currencyName }}未分配
            </span>
            <span class="fr" @click="averageDistibute">平均分配</span>
        </div>
        <div class="table-box">
            <a-table
                :row-selection="rowSelection"
                :pagination="false"
                :columns="columns"
                :data-source="members"
                :rowKey="
                    (record, index) => {
                        return index;
                    }
                "
            >
                <p slot="coinNum" slot-scope="text, record">
                    <a-input-number
                        :key="record.key"
                        :disabled="inputDisable(record)"
                        placeholder="请输入"
                        v-model="record.coinNum"
                        :min="0"
                        :max="1000000000000000"
                        :precision="2"
                    />
                </p>
            </a-table>
        </div>
        <div class="distribute-tips">
            已选择
            <span class="fw">{{ selectMember.length }}</span>
            位成员，即将分配
            <span class="fw">{{ distributeCoin }}</span>
        </div>
    </div>
</template>
<script>
    import { clac, average } from '../../../../config/math';

    export default {
        props: {
            members: {
                type: Array,
                default: () => [],
            },
            totalCoin: {
                type: Number,
                default: 0,
            },
            chosenCoin: {
                type: Number,
                default: 0,
            },
        },
        model: {
            prop: 'members',
            event: 'updateMembersForCoinChange',
        },
        data: () => ({
            // 选中的成员（分配学币）
            selectMember: [],
            columns: [
                {
                    title: '成员名称',
                    dataIndex: 'memberName',
                },
                {
                    title: '分配数额',
                    key: 'coinNum',
                    scopedSlots: { customRender: 'coinNum' },
                },
            ],
        }),
        computed: {
            rowSelection() {
                return {
                    onChange: (indexArr, selectedRows) => {
                        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                        this.$emit(
                            'updateMembersForCoinChange',
                            this.members.map((m) => {
                                m.selected = false;
                                return m;
                            })
                        );
                        selectedRows.forEach((member) => {
                            member.selected = true;
                        });
                        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                        this.selectMember = selectedRows;
                    },
                    getCheckboxProps: (record) => {
                        return {
                            props: {
                                checked: record.selected === true,
                            },
                        };
                    },
                };
            },
            distributeCoin() {
                return this.selectMember.reduce((acc, member) => {
                    if (Number(member.coinNum)) {
                        return clac('+', acc, Number(member.coinNum));
                    }
                    return acc;
                }, 0);
            },
            remainCoin() {
                return clac('-', this.totalCoin, this.distributeCoin);
            },
            inputDisable() {
                return function (record) {
                    return !record.selected;
                };
            },
            currencyName() {
                return this.$store.state.app.currencyName || '';
            },
        },
        methods: {
            averageDistibute() {
                // 未选择，不允许平均分配
                if (this.selectMember.length === 0) {
                    this.$notification.warn({ message: '请先选择要分配的对象！' });
                    return;
                }
                // 先清空原有数据
                const memberWithNoCoin = this.members.map((member) => {
                    if (member.coinNum) {
                        member.coinNum = '';
                    }
                    return member;
                });
                this.$emit('updateMembersForCoinChange', memberWithNoCoin);
                const averageArr = average(this.totalCoin, this.selectMember.length);
                const membersWithCoin = this.selectMember.map((member, index) => {
                    member.coinNum = averageArr[index];
                    return member;
                });
                this.selectMember = membersWithCoin;
            },
        },
    };
</script>
<style lang="less">
.fl-col {
    color: #e79152;
}
.icon-distribution {
    .title-box {
        font-size: 12px;
        margin-bottom: 15px;
        .fr {
            color: #00aeff;
            cursor: pointer;
        }
    }
    .distribute-tips {
        margin-top: 12px;
        font-size: 12px;
    }
    .icon-input {
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 2px;
        text-indent: 10px;
    }
    .ant-input-number-handler-wrap {
        display: none;
    }
}
</style>
